import type { BoostPayload } from '../types';

interface BoostCardProps {
    boost: BoostPayload;
    action: 'recycle' | 'trash' | 'special_dropoff';
}

const actionEmojis = {
    recycle: '♻️',
    trash: '🗑️',
    special_dropoff: '📍'
};

const actionLabels = {
    recycle: 'Recycle It!',
    trash: 'Trash It',
    special_dropoff: 'Special Drop-off'
};

export default function BoostCard({ boost, action }: BoostCardProps) {
    return (
        <div className="boost-card animate-float">
            {/* Celebration Header */}
            <div className="text-center mb-4">
                <div className="text-5xl mb-2">🎉</div>
                <h2 className="text-2xl font-bold">{boost.headline}</h2>
                <p className="text-primary-100 mt-1">{boost.praise_line}</p>
            </div>

            {/* Action Badge */}
            <div className="bg-white/20 rounded-2xl p-4 mb-4">
                <div className="flex items-center justify-center gap-3">
                    <span className="text-4xl">{actionEmojis[action]}</span>
                    <span className="text-xl font-bold">{actionLabels[action]}</span>
                </div>
            </div>

            {/* Impact Stats */}
            <div className="space-y-3 text-sm">
                <div className="flex items-start gap-2">
                    <span className="text-lg">🌱</span>
                    <p>{boost.impact_line}</p>
                </div>
                <div className="flex items-start gap-2">
                    <span className="text-lg">💡</span>
                    <p>{boost.fun_fact}</p>
                </div>
                {boost.streak_line && (
                    <div className="flex items-start gap-2">
                        <span className="text-lg">🔥</span>
                        <p>{boost.streak_line}</p>
                    </div>
                )}
                {boost.badge_line && (
                    <div className="flex items-start gap-2">
                        <span className="text-lg">🏆</span>
                        <p className="font-semibold">{boost.badge_line}</p>
                    </div>
                )}
            </div>
        </div>
    );
}
